module.exports = __webpack_public_path__ + "img/thumb-008-05.b4552ecf.png";